<template>
  <l-rows>
    <back-office-form
      :inputs="inputs"
      mode="create"
      :modes="modes"
      @submit="createCasinoIntegrationOption"
    />
  </l-rows>
</template>

<script>
  import { LRows, } from 'codefabrik-gui-vue'
  import BackOfficeForm from '@/components/BackOfficeForm'
  import { useCreateCasinoIntegrationOption } from '@/views/casinos/casinoHooks'
  import {DataTypeSelect} from "@/components";

  export default {
    name: 'CasinoIntegrationOptionCreate',
    components: { BackOfficeForm, LRows, },
    computed: {
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              label: this.$t('common.name')
            }
          },
          {
            name: 'dataType',
            is: DataTypeSelect,
            validators: 'required',
            properties: {
              label: this.$t('common.dataType')
            }
          },
          {
            name: 'description',
            properties: {
              label: this.$t('common.description')
            }
          }
        ]
      },
      modes () {
        return {
          create: {
            title: 'casinos.createCasinoIntegrationOption',
            subtitles: ['']
          },
        }
      }
    },
    mixins: [useCreateCasinoIntegrationOption()]
  }
</script>

<style scoped>

</style>
